export default __webpack_public_path__ + "static/media/risk.596340d3.jpg";